import { memo, ReactNode } from "react";
import { Html5DndProviderSingleton } from "../dnd/html5-dnd-provider-singleton";
import { Flex } from "../flex";
import { HeightValue } from "../theme/box";
import { FormElementDragLayer } from "./form-element-drag-layer";

export const FormBuilderPageWrapper = memo(function FormBuilderPageWrapper({
  children,
  height,
}: {
  children: ReactNode;
  height?: HeightValue | undefined;
}) {
  return (
    <Html5DndProviderSingleton>
      <FormElementDragLayer />
      <Flex
        bgColor="secondary"
        dir="column"
        gap="none"
        grow="1"
        height={height}
        textColor="primary"
        w="full"
      >
        {children}
      </Flex>
    </Html5DndProviderSingleton>
  );
});
